import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './Portfolio.jsx'; // Assuming your main component is now named App.jsx

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);